const Handlebars = require('handlebars/runtime');

Handlebars.registerHelper('increment', function (index) {
    index++;
    return index;
});

/**
* Handlebars runtime with custom helpers.
* Used by handlebars-loader.
*/
module.exports = Handlebars;


// WEBPACK FOOTER //
// ./src/js/proj/customHelpers.js